module.exports = __webpack_public_path__ + "static/media/pintura.456c3cdc.jpeg";